import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    unselectAll: translate({ id: 'orders.grid.header.unselectAll' }),
    selectAll: translate({ id: 'orders.grid.header.selectAll' }),
  }))

  return api
}
